import { config } from '../../Config';

export const GetChatStatus = async (chatId, userId) => {
    const url = config.getChatStatus;

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ chatId, userId })
        });

        if (!response.ok) {
            throw new Error(`Failed to fetch chat status: ${response.statusText}`);
        }

        const data = await response.json();
        return data.status;
    } catch (error) {
        // console.error("Error fetching chat status:", error);
        return null;
    }
};

export default GetChatStatus;
